export const TIMER_STATE = {
  INIT: 'INIT',
  PLAY: 'PLAY',
  PAUSE: 'PAUSE',
  STOP: 'STOP',
} as const;

export type TimerStateType = keyof typeof TIMER_STATE;
